var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"btn-pet",class:{ 'btn-pet-active': _vm.active },on:{"click":_vm.selectPet}},[_c('div',{staticClass:"btn-pet-name"},[_vm._v(_vm._s(_vm.pet.name))]),_c('div',{staticClass:"btn-pet-breed"},[_vm._v(_vm._s(_vm.breedName))])])
}
var staticRenderFns = []

export { render, staticRenderFns }